import { Outlet } from 'react-router-dom'
import TopBar from './TopBar'
import BottomNav from './BottomNav'
import Sidebar from './Sidebar'
import FAB from './FAB'
import ToastContainer from '@/components/ui/Toast'
import { useState, useEffect } from 'react'
import { useSpaceStore } from '@/stores/spaceStore'
import { useTagsStore } from '@/stores/tagsStore'
import { useTemplateStore } from '@/stores/templateStore'
import { useEventStore } from '@/stores/eventStore'
import { scheduleReminderCheck } from '@/lib/notifications'
import styles from './MainLayout.module.css'

export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const loadSpaces = useSpaceStore(s => s.loadSpaces)
  const loadTags = useTagsStore(s => s.loadTags)
  const loadTemplates = useTemplateStore(s => s.loadTemplates)
  const loadEvents = useEventStore(s => s.loadEvents)

  useEffect(() => {
    (async () => {
      await loadSpaces()
      await Promise.all([loadTags(), loadTemplates(), loadEvents()])
      scheduleReminderCheck()
    })()
  }, [loadSpaces, loadTags, loadTemplates, loadEvents])

  return (
    <div className={styles.shell}>
      <TopBar onMenuClick={() => setSidebarOpen(true)} />
      <main className={styles.content}>
        <Outlet />
      </main>
      <BottomNav />
      <FAB />
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <ToastContainer />
    </div>
  )
}
